// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const th = {
  games: 'เกม',
  game_history: 'ประวัติการเล่นเกม',
  bet_amount: 'จำนวนเงินเดิมพัน',
  login: 'เข้าสู่ระบบ',
  register: 'ลงทะเบียน',
  username_placeholder: 'ชื่อผู้ใช้',
  please_input_your_x: 'กรุณากรอก {{x}} ของคุณ',
  verification_code: 'รหัสยืนยัน',
  press_get_code: 'กดปุ่มรับรหัสเพื่อรับรหัสยืนยันทาง SMS',
  otp_sent: 'รหัสยืนยันถูกส่งแล้ว! กรุณากรอกรหัสด้านล่างเพื่อดำเนินการต่อ',
  your_otp_expire: 'รหัส OTP ของคุณจะหมดอายุใน',
  get_code: 'รับรหัส',
  didnt_receive: 'ไม่ได้รับข้อความ?',
  send_again: 'ส่งอีกครั้ง',
  captcha: 'CAPTCHA',
  forgot_password: 'ลืมรหัสผ่าน',
  minor_note: 'ในการเข้าใช้เว็บไซต์นี้ โปรดตรวจสอบว่าคุณมีอายุมากกว่า 18 ปีและยอมรับ',
  terms_of_service: 'ข้อกำหนดการให้บริการ',
  by_signing_in: 'เมื่อเข้าสู่ระบบหรือลงทะเบียน แสดงว่าคุณยอมรับ',
  dont_have_account: 'ยังไม่มีบัญชีใช่ไหม?',
  sign_up: 'สมัครสมาชิก',
  username: 'ชื่อผู้ใช้',
  email: 'อีเมล',
  full_name: 'ชื่อเต็ม',
  confirm_18: 'ฉันยืนยันว่าฉันมีอายุ 18 ปีขึ้นไปและฉันได้อ่าน',
  already_have_account: 'มีบัญชีอยู่แล้ว?',
  deposit: 'ฝากเงิน',
  bonus: 'โบนัส',
  load_more: 'โหลดเพิ่มเติม',
  responsible_gaming: 'การเล่นเกมอย่างมีความรับผิดชอบ',
  faq: 'คำถามที่พบบ่อย',
  amount: 'จำนวนเงิน',
  extra: 'พิเศษ',
  deposit_bonus: 'โบนัสเงินฝาก',
  withdraw: 'ถอนเงิน',
  min: 'ขั้นต่ำ:',
  max: 'สูงสุด:',
  notifications: 'การแจ้งเตือน',
  invalid_x: '{{x}} ไม่ถูกต้อง',
  captcha_not_match: 'CAPTCHA ไม่ตรงกัน',
  invalid_x_must_be_atleast_y_characters: '{{x}} ไม่ถูกต้อง ต้องมีอย่างน้อย {{y}} ตัวอักษร',
  x_is_required: 'ต้องระบุ {{x}}',
  phone_number: 'หมายเลขโทรศัพท์',
  phone_num_x_max: 'หมายเลขโทรศัพท์สูงสุด {{x}} หลัก',
  email_sent: 'ส่งอีเมลแล้ว กรุณาตรวจสอบอีเมลของคุณ',
  enter_valid_email: 'กรุณากรอกอีเมลที่ถูกต้อง',
  confirm: 'ยืนยัน',
  password_atleast_6_characters: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
  password_reset_success: 'รีเซ็ตรหัสผ่านสำเร็จ!',
  new_password: 'รหัสผ่านใหม่',
  bank: 'ธนาคาร',
  bank_name: 'ชื่อธนาคาร',
  bank_branch: 'รหัสสาขาธนาคาร',
  pay_id: 'Pay ID',
  account_name: 'ชื่อบัญชี',
  account_number: 'หมายเลขบัญชี',
  drop_or_select: 'ลากหรือเลือกไฟล์',
  drop_files_here: 'ลากไฟล์มาที่นี่',
  transfer_to: 'โอนไปยัง',
  upload_receipt: 'อัปโหลดใบเสร็จ',
  select_bonus: 'เลือกโบนัส',
  no_promotion: 'ไม่มีโปรโมชั่น',
  please_upload_receipt: 'กรุณาอัปโหลดใบเสร็จ',
  bank_account: 'บัญชีธนาคาร',
  add_account: 'เพิ่มบัญชี',
  account_holder_name: 'ชื่อเจ้าของบัญชี',
  name_of_the_account_holder: 'ชื่อของเจ้าของบัญชี',
  fill_in_bank_account: 'กรอกข้อมูลบัญชีธนาคาร',
  withdraw_information: 'ข้อมูลการถอนเงิน',
  note: 'หมายเหตุ',
  amount_withdrawn: 'จำนวนเงินที่ถอน',
  amount_no_exceed_balance: 'จำนวนเงินถอนต้องไม่เกินยอดเงินคงเหลือ',
  minimum_withdraw_amount_is_x: 'จำนวนถอนขั้นต่ำคือ {{x}}',
  transaction_history: 'ประวัติธุรกรรม',
  date_from: 'วันที่เริ่มต้น',
  date_to: 'วันที่สิ้นสุด',
  account_name_must_be_4: 'ชื่อบัญชีต้องมีความยาวมากกว่า 4 ตัวอักษร',
  minimum_length_is_x: 'ความยาวขั้นต่ำคือ {{x}}',
  maximum_length_is_x: 'ความยาวสูงสุดคือ {{x}}',
  payment_method: 'วิธีการชำระเงิน',
  no_bank_account: 'คุณไม่มีบัญชีสำหรับถอนเงิน โปรดเพิ่มบัญชี',
  bet_history: 'ประวัติการเดิมพัน',
  game_provider: 'ผู้ให้บริการเกม',
  bet_count: 'จำนวนเดิมพัน',
  win_loss: 'ชนะ/แพ้',
  rebate: 'เงินคืน',
  turnover: 'ยอดหมุนเวียน',
  game_category: 'หมวดหมู่เกม',
  you_have_x_unread_messages: 'คุณมี {{x}} ข้อความที่ยังไม่ได้อ่าน',
  deposit_amount_between_x_and_y: 'จำนวนเงินฝากต้องอยู่ระหว่าง {{x}} และ {{y}}',
  minimum_amount_is_x_y: 'จำนวนเงินขั้นต่ำคือ {{x}} {{y}}',
  all: 'ทั้งหมด',
  title: 'หัวข้อ',
  date: 'วันที่',
  type: 'ประเภท',
  status: 'สถานะ',
  remark: 'หมายเหตุ',
  category: 'หมวดหมู่',
  please_select_x: 'กรุณาเลือก {{x}}',
  save: 'บันทึก',
  change_password: 'เปลี่ยนรหัสผ่าน',
  current_password: 'รหัสผ่านปัจจุบัน',
  confirm_password: 'ยืนยันรหัสผ่านใหม่',
  submit: 'ส่ง',
  password_changed: 'เปลี่ยนรหัสผ่านแล้ว',
  x_must_be_y_characters: '{{x}} ต้องมีอย่างน้อย {{y}} ตัวอักษร',
  reset_password: 'รีเซ็ตรหัสผ่าน',
  slots: 'สล็อต',
  live_casino: 'คาสิโนสด',
  clear: 'ล้าง',
  search: 'ค้นหา',
  new: 'ใหม่',
  logout: 'ออกจากระบบ',
  choose_date: 'เลือกวันที่',
  select_both_date: 'เลือกทั้งวันที่เริ่มต้นและสิ้นสุด',
  from: 'จาก',
  to: 'ถึง',
  apply: 'ยืนยัน',
  promotions: 'โปรโมชั่น',
  learn_more: 'เรียนรู้เพิ่มเติม',
  password_doesnt_match: 'รหัสผ่านไม่ตรงกัน',
  cancel: 'ยกเลิก',
  confirm_to_pay: 'ยืนยันการชำระเงิน',
  deposit_amount: 'จำนวนเงินฝาก',
  loading_please_wait: 'กำลังโหลด กรุณารอสักครู่',
  account: 'บัญชี',
  profile: 'โปรไฟล์',
  bank_list: 'รายการธนาคาร',
  in_maintenance: 'อยู่ระหว่างการบำรุงรักษา',
  birthday: 'วันเกิด',
  birthday_bonus: 'กรอกวันเกิดของคุณเพื่อรับโบนัส! 🎉🎁',
  referral_code: 'รหัสแนะนำ',
  referral: 'แนะนำเพื่อน',
  my_referral: 'เพื่อนที่ฉันแนะนำ',
  my_claim: 'การเคลมของฉัน',
  claim_profit: 'เคลมกำไร',
  available_profit: 'กำไรที่ใช้ได้',
  claimed_profit: 'กำไรที่เคลมแล้ว',
  all_time_profit: 'กำไรรวมทั้งหมด',
  referral_note_on_x: 'รับกำไรทุกครั้งที่เพื่อนของคุณเล่นบน {{x}}',
  tier: 'ระดับ',
  commission: 'ค่าคอมมิชชั่น',
  referred_member: 'สมาชิกที่แนะนำ',
  profit_earned: 'กำไรที่ได้รับ',
  account_information: 'ข้อมูลบัญชี',
  invite_friends: 'เชิญเพื่อน',
  how_it_work: 'วิธีการทำงาน?',
  invite_note: 'รับโบนัสแนะนำพิเศษ เมื่อเพื่อนของคุณสมัครโดยใช้รหัสแนะนำของคุณ!',
  share_via: 'แชร์ผ่าน',
  referral_link: 'ลิงก์แนะนำ',
  total_profit: 'กำไรรวม',
  copied: 'คัดลอกแล้ว',
  nothing_to_claim: 'ไม่มีรายการให้เคลม',
  claim_history: 'ประวัติการเคลม',
  downline: 'ดาวน์ไลน์',
  last_x_digit_bank_ref_number: 'เลขอ้างอิงธนาคาร {{x}} หลักสุดท้าย',
  bank_ref_number_validation_x: 'หมายเลขอ้างอิงธนาคารจำเป็นต้องมี {{x}} ตัวอักษร',
  login_directly: 'เข้าสู่ระบบโดยตรงด้วย',
  our_game_provides: 'ผู้ให้บริการเกมของเรา',
  linked_successfully_x: 'เชื่อมต่อกับ {{x}} สำเร็จ! กรุณาลงทะเบียนบัญชีของคุณเป็นครั้งแรก',
  more_x_of_y: 'เพิ่มเติม {{x}}/{{y}}',
  agent: 'ตัวแทน',
  download: 'ดาวน์โหลด',
  popular: 'ยอดนิยม',
  claim_bonus: 'เคลมโบนัส',
  currently_displaying: 'กำลังแสดง {{x}} {{y}} เกมจากทั้งหมด {{z}}',
  no_results: 'ไม่พบผลลัพธ์',
  please_scan_using_your: 'กรุณาสแกนโดยใช้',
  activity_rules: 'กฎของกิจกรรม:',
  event_instructions: 'คำแนะนำกิจกรรม',
  agent_p1: 'แชร์ลิงก์เฉพาะของคุณผ่านแอปและโซเชียลมีเดีย',
  agent_p2:
    'Facebook, Instagram, Tiktok, Telegram, WhatsApp, YouTube และอื่นๆ รีบเชิญทุกคน สมาชิกที่ลงทะเบียนผ่านลิงก์พิเศษของคุณจะกลายเป็นตัวแทนโดยตรงของคุณ แต่โปรดทราบว่าสมาชิกใหม่ที่คุณเชิญต้องเป็นของแท้และถูกต้อง',
  agent_step1:
    'เชิญเพื่อนให้ฝากเงินครั้งแรกสำเร็จ คุณสามารถรับโบนัส R$5 ตัวอย่างเช่น หากคุณเชิญ 10 คนให้ฝากเงินครั้งแรก คุณสามารถรับ R$50 ยิ่งเชิญมาก ยิ่งได้รับโบนัสมากขึ้น คุณสามารถดูประวัติและลงทะเบียนในหน้ากิจกรรมเพื่อรับโบนัสและค่าคอมมิชชั่นสูง',
  agent_step2:
    'หากผู้ที่คุณเชิญวางเดิมพัน R$1 หรือมากกว่า คุณสามารถเพลิดเพลินกับค่าคอมมิชชั่นสูงได้แล้ว! คุณสามารถรับค่าคอมมิชชั่นสูงสุดถึง 5% ตลอดชีพ และคำเชิญตลอดชีพ! ระบบจะคำนวณค่าคอมมิชชั่นของวันก่อนหน้าเวลา 07:00 น. ของวันถัดไป',
  agent_step2_1: 'วิธีรับ: เข้าสู่ระบบ - โปรโมชั่นเชิญเพื่อน - รับค่าคอมมิชชั่น',
  agent_table1: 'อัตราค่าคอมมิชชั่นการเดิมพันสำหรับสล็อต เกมยิงปลา และบล็อกเชนมีดังนี้:',
  agent_table1_1: 'ลูกค้าฝากเงิน 20 เดิมพัน 200',
  person: 'คน',
  agent_table2_title1: 'การเดิมพันของสมาชิก',
  agent_table2_title2: 'เฉพาะเกมสล็อต',
  agent_table2_example:
    'ตัวอย่าง: คุณมีสมาชิก 100 คน และมูลค่าการเดิมพันจริงรวมต่อวันประมาณ 1 ล้านเรียล ค่าคอมมิชชั่นที่คุณได้รับในวันนั้นคือ: 1,000,000 x 1.20% = 12,000 เรียล รายได้ต่อเดือน 100,000 เรียลเป็นเรื่องง่าย!',
  reminder: 'เตือนความจำ',
  agent_reminder:
    'บัญชีสมาชิกที่มี IP เดียวกัน อุปกรณ์เดียวกัน ชื่อเดียวกัน บัญชีธนาคารเดียวกัน และข้อมูลอื่นๆ สามารถเข้าร่วมได้เพียงครั้งเดียวเท่านั้น และใครก็ตามที่ละเมิดกฎจะไม่ได้รับโบนัสนี้ หรือบัญชีจะถูกยึดและถูกระงับถาวร',
  agent_step3_1:
    'การเข้าร่วมกิจกรรมของสมาชิกจะถูกนับโดยอัตโนมัติโดยระบบ หากมีข้อโต้แย้ง ผลการวิเคราะห์ของ IFUN168 จะเป็นที่สิ้นสุด',
  agent_step3_2:
    'หากคุณลืมบัญชี/รหัสผ่านสมาชิก กรุณาติดต่อฝ่ายบริการลูกค้า 24 ชั่วโมงของเราเพื่อกู้คืนข้อมูลบัญชีของคุณ',
  agent_step3_3: 'IFUN168 ขอสงวนสิทธิ์ในการเปลี่ยนแปลง หยุด หรือยกเลิกโปรโมชั่นได้ตลอดเวลา',
  agent_step3_4: 'ตัวแทนสามารถรับโบนัสค่าคอมมิชชั่นได้เป็นเงินสดหรือเครดิตในกระเป๋าเงิน',
  agent_step3_5: 'ห้ามบันทึกเกมฟรี ซื้อเกมฟรี',
  agent_step3_6: 'ไม่สามารถใช้ร่วมกับโบนัสหรือเงินฝากใดๆ',
  agent_step3_7: 'ใช้ได้เฉพาะเกมสล็อตเท่านั้น',
  promo_concluded: 'โปรโมชั่นสิ้นสุดแล้ว! กลับมาตรวจสอบอีกครั้งพรุ่งนี้!',
  can_only_claim: 'สามารถรับโบนัสได้ระหว่าง {{x}} ถึง {{y}} เวลาประเทศไทย',
  please_login: 'กรุณาเข้าสู่ระบบก่อนรับโบนัส!',
  back_to_home: 'กลับไปที่หน้าหลัก',
  bonus_claimed: 'รับโบนัสแล้ว!',
  terms_n_conditions: 'ข้อกำหนดและเงื่อนไข',
  the_activity_x_in: 'กิจกรรม {{x}} ใน',
  starts: 'เริ่มต้น',
  ends: 'สิ้นสุด',
  list_of_winners: 'รายชื่อผู้ชนะ',
  days: 'วัน',
  hours: 'ชั่วโมง',
  minutes: 'นาที',
  seconds: 'วินาที',
  apply_now: 'สมัครตอนนี้',
  number_exists: 'หมายเลขโทรศัพท์นี้ได้ลงทะเบียนแล้ว!',
  number_not_exists: 'หมายเลขโทรศัพท์นี้ยังไม่ได้ลงทะเบียน!',
  payment_draft: 'หากคุณยืนยันว่าชำระเงินแล้ว โปรดรอสักครู่เนื่องจากการชำระเงินอาจยังอยู่ระหว่างดำเนินการ',
  downline_name: 'ชื่อดาวน์ไลน์',
  date_joined: 'วันที่เข้าร่วม',
  deposit_amount_x_days: 'ยอดฝาก ({{x}} วัน)',
  dont_show_again: 'ไม่ต้องแสดงอีก',
  next: 'ถัดไป',
  close: 'ปิด',
  no_balance: 'ยอดคงเหลือไม่เพียงพอ',
  menu: 'เมนู',
  vip_club: 'VIP Club',
  home: 'หน้าหลัก',
  lobby: 'ล็อบบี้',
  show_all: 'แสดงทั้งหมด',
  game_name: 'ชื่อเกม',
  sub_filters: 'ตัวกรองย่อย',
  contact_us_24: 'ติดต่อเราตลอด 24 ชั่วโมง',
  live_chat: 'แชทสด',
  chat_now: 'แชทเลย',
  gaming_license: 'ใบอนุญาตการเล่นเกม',
  certification: 'ใบรับรอง',
  security: 'ความปลอดภัย',
  threatmetrix: 'ThreatMetrix',
  gaming_license_caption:
    'IFUN168 เป็นหน่วยงานที่ได้รับใบอนุญาตและควบคุมโดยรัฐบาลคูราเซา และดำเนินงานอย่างถูกกฎหมายภายใต้ใบอนุญาต Master License of Gaming Services Provider, N.V #365/JAZ',
  no_limits: 'ไม่จำกัด',
  vip_description_no_limits:
    'เรามอบบริการ VIP ส่วนตัวพร้อมเงื่อนไขการเล่นเกมที่ไม่เหมือนใครให้กับผู้เล่นทุกคนใน VIP Club ตอนนี้คุณสามารถเล่นได้อย่างไร้กังวล! ง่ายมาก - เล่นเพื่อความตื่นเต้น พัฒนาทักษะการเล่น สนุกกับเวลา และรับโอกาสชนะไม่จำกัด!',
  financial_privileges: 'สิทธิพิเศษทางการเงิน',
  vip_description_financial_privileges:
    'VIP Club ต้อนรับผู้เล่นทุกคนที่ต้องการรับบริการ VIP คุณภาพสูง สิทธิพิเศษ โปรโมชั่นพิเศษ และสิทธิประโยชน์มากมายรอคุณอยู่ที่เว็บไซต์ของเรา! สถานะ VIP ของคุณปลดล็อกขีดจำกัดการถอนเงินที่สูงขึ้นในระยะเวลาที่สั้นที่สุด!',
  personal_manager: 'ผู้จัดการส่วนตัว',
  vip_description_personal_manager:
    'สิทธิประโยชน์ใดที่คุณต้องการเมื่อเป็นผู้เล่น VIP? แบ่งปันความคิดเห็นของคุณกับผู้จัดการส่วนตัวของคุณ และแจ้งให้เราทราบว่าคุณต้องการเห็นอะไรเพิ่มเติมในเว็บไซต์ของเรา! เราพร้อมรับฟังข้อเสนอที่ยอดเยี่ยมเสมอ!',
  vip_promotions: 'โปรโมชั่น VIP',
  vip_description_vip_promotions:
    'คุณต้องการรับโปรโมชั่นที่ยอดเยี่ยมเพิ่มเติมหรือไม่? ผู้เล่น VIP ได้รับสิทธิพิเศษมากมายเพื่อเป็นรางวัลสำหรับความภักดี! มาเป็นหนึ่งในนั้น!',
  withdraw_limit: 'ขีดจำกัดการถอนเงิน',
  monthly: 'รายเดือน',
  weekly: 'รายสัปดาห์',
  annual: 'รายปี',
  cashback: 'เงินคืน',
  personal_account_manager: 'ผู้จัดการบัญชีส่วนตัว',
  yes: 'ใช่',
  join_the_vip: 'เข้าร่วมโปรแกรม VIP ทันที!',
  join_now: 'เข้าร่วมเดี๋ยวนี้',
  play_the_way_you_want: 'เล่นได้ตามที่คุณต้องการ',
  more_info: 'ข้อมูลเพิ่มเติม',
  nothing_to_show: 'ไม่มีข้อมูลที่จะแสดง',
  remarks: 'หมายเหตุ',
  password: 'รหัสผ่าน',
  back: 'กลับ',
  new_to_x: 'ใหม่กับ {{x}}',
  create_an_account: 'สร้างบัญชี',
  withdraw_amount: 'จำนวนเงินที่ถอน',
  balance: 'ยอดคงเหลือ',
  bank_bsb: 'รหัส BSB ธนาคาร',
  enter_bank_branch: 'กรอกสาขาธนาคาร',
  enter_pay_id: 'กรอก Pay ID',
  level: 'ระดับ',
  claimed: 'รับแล้ว',
  not_found: 'ไม่พบข้อมูล',
  become_a_vip: 'เป็นสมาชิก VIP',
  otp_not_found: 'ยังไม่ได้ตั้งค่า OTP',
  resend_again: 'ส่งอีกครั้ง',
  how_to_get_referral_bonus: 'วิธีรับโบนัสแนะนำเพื่อน?',
  steps_to_claim: 'ขั้นตอนการรับโบนัส',
  share_your_referral_code: '1. แชร์รหัสแนะนำของคุณให้เพื่อนสมัครบัญชีผ่าน Facebook, Twitter หรือ WhatsApp',
  after_friend_register:
    '2. หลังจากเพื่อนลงทะเบียนกับ IFUN168 ทั้งผู้แนะนำและสมาชิกที่ถูกแนะนำต้องทำการฝากเงินเพื่อรับโบนัสนี้',
  refer_a_friend_bonus: '3. การคำนวณโบนัสแนะนำเพื่อน:',
  turnover_played: 'ยอดเดิมพัน x เปอร์เซ็นต์ค่าคอมมิชชั่น = โบนัสแนะนำเพื่อน',
  example: 'ตัวอย่าง:',
  turnover_formula_x: 'ยอดเดิมพัน (1,000,000) x 0.002% (ค่าคอมมิชชั่น) = 2,000{{x}}',
  note_bonus_only: '*หมายเหตุ: สามารถรับโบนัสได้ในวันถัดไปหลังเที่ยงคืน',
  note_bonus_only_x: '*หมายเหตุ: สามารถรับโบนัสได้ในวันถัดไปหลัง {{x}}',
  access_dashboard: '4. เข้าสู่แดชบอร์ดเพื่อตรวจสอบกำไรที่ได้รับ ระดับค่าคอมมิชชั่น ประวัติการรับโบนัส และดาวน์ไลน์',
  highlights: 'ไฮไลท์',
  event: 'กิจกรรม',
  information: 'ข้อมูล',
  casino: 'คาสิโน',
  fish: 'ยิงปลา',
  sports: 'กีฬา',
  card: 'ไพ่',
  popular_games: 'เกมยอดนิยม',
  game_providers: 'ผู้ให้บริการเกม',
  leaderboard: 'กระดานผู้นำ',
  winnings: 'เงินรางวัล',
  vip_member_level: 'ระดับสมาชิก VIP',
  change_language: 'เปลี่ยนภาษา',
  contact: 'ติดต่อ',
  choose_deposit_method: 'เลือกวิธีการฝากเงิน',
  your_bank_account: 'บัญชีธนาคารของคุณ',
  x_games: '{{x}} เกม',
  x_game: '{{x}} เกม',
  fishing: 'ยิงปลา',
  please_enter_email: 'กรุณากรอกอีเมลของคุณ',
  please_enter_new_password: 'กรุณากรอกรหัสผ่านใหม่ของคุณ',
  password_not_match: 'รหัสผ่านไม่ตรงกัน',
  confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
  must_start_with: 'หมายเลขโทรศัพท์ต้องมีอย่างน้อย 10 หลัก และต้องขึ้นต้นด้วย (06, 08 หรือ 09)',
  first_name: 'ชื่อจริง',
  last_name: 'นามสกุล',
  to_proceed_further_add_bank: 'เพื่อดำเนินการต่อ โปรดกรอกข้อมูลธนาคารของคุณ',
  please_select_bank: 'กรุณาเลือกธนาคาร',
  leave_empty_if_same_as_above: 'ปล่อยว่างหากเหมือนกับด้านบน',
  deposit_from_bank: 'ฝากเงินจากธนาคาร',
  select_language: 'เลือกภาษา',
  logout_confirmation: 'ยืนยันการออกจากระบบ',
  are_you_sure_to_logout: 'คุณแน่ใจว่าต้องการออกจากระบบหรือไม่?',
};

export default th;
